<template>
    <div v-if="settings.show">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <b-modal v-model="showBulkPlacementPopup"
                 :content-class=" 'custom-modal bulk_placement-popup ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onCancelClick"></span>
            </template>
            <h2 class="modal-title">{{translate('bulkPlacement')}}</h2>
            <div class="suggests-search">
                <div class="search">
                    <div class="search__wrapper">
                        <div class="img">
                            <img src="@/assets/images/ic_search.png">
                        </div>
                        <div class="input">
                            <input type="text"
                                   :placeholder="translate('Filter')"
                                   v-model="filterValue">
                        </div>
                    </div>
                    <div class="search__wrapper">
                        <div class="img placement">
                            <img src="@/assets/icons/ic_house.svg">
                        </div>
                        <div class="input">
                            <input type="text"
                                   :placeholder="translate('bulkInputPlaceHolder')"
                                   v-model="newPlaceValue">
                        </div>
                    </div>
                </div>
                <div class="results">
                    <div class="progress-wrapper" v-if="loading">
                        <md-progress-spinner id="progressbar" :md-diameter="60"
                                             md-mode="indeterminate" class="mapProgressVotes"></md-progress-spinner>
                    </div>
                    <div class="questionList" v-else>
                        <div class="checkBox-selectAll">
                            <div>
                                <b-form-checkbox v-model="selectAllQuestions" @input="onSelectAllInput">
                                    <span>{{translate('bulkPlacementPopupSelectAll')}}</span>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <div class="questionItem" >
                            <div class="questionItem__wrapper">
                                <div v-for="(item, index) in reportItems" :key="item.id"
                                     v-if="index < itemsShow" >
                                        <b-form-checkbox @change="onCheckboxInput(item)" v-model="item.checked">
                                            <span>#{{item.id}} | {{item.text}}<div class="questionItem__plase">{{item.placement}}</div></span>
                                        </b-form-checkbox>
                                </div>
                                <div class="showMore__btn-wrapper">
                                    <b-button @click="showMoreForItem(reportItems)"  class="showMore__btn"
                                              v-if="showMoreButton">{{translate('own_showMore')}}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <div class="suggests-search footer">
                            <div class="search">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="checkedQuestion">
                <div class="checkedQuestion__wrapper">
                    <div>
                        {{translate('bulkPlacementPopupSavedQuestions')}}: {{checkedQuestions.size}}
                    </div>
                </div>
            </div>
            <template v-slot:modal-footer>
                <div class="footer-buttons">
                    <div class="saveBtn" :class="{'disable': checkedQuestions.size == 0}" @click="saveNewPlaceClick">
                        {{translate('Save')}}
                    </div>
                    <div class="cancelBtn" @click="onCancelClick">
                        {{translate('Cancel')}}
                    </div>
                </div>

            </template>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import errorMixin from '@/mixins/errorMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';

    export default {
        name: "bulkPlacementPopup",
        mixins: [errorMixin],
        components: {
            customModalDialog
        },
        data() {
            return {
                loading: true,
                showBulkPlacementPopup: _.isEmpty(this.settings),
                reportItems: null,
                checkedQuestions: new Set(),
                selectAllQuestions: false,
                originalItems: [],
                filterValue: '',
                newPlaceValue: '',
                customModalSettings: {},
                itemsShowCount: 100,
                showMoreButton: false,
                itemsShow: null
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {

                    }
                }
            },
        },
        watch: {
            settings(newValue) {
                this.showBulkPlacementPopup = !_.isEmpty(newValue)
                this.getReport()
            },
            filterValue(newValue) {
                this.applyFilter(newValue)
            }

        },
        computed: {
            ...mapState({
                showReportByChosen: state => state.owner.showReportByChosen,
            }),
        },
        methods: {
            ...mapActions({
                getManagerReportAction: 'owner/getManagerReport',
                fetchQuestionsByOrganization: 'organization/fetchQuestionsByOrganization',
                bulkPlaceEdit: 'question/bulkPlaceEdit',
            }),
            ...mapMutations({
                setProgressBarTag: 'setProgressBarTag'
            }),
            onCancelClick() {
                this.showBulkPlacementPopup = false
            },
            onSelectAllInput() {
                for(let i = 0; this.reportItems.length > i; i++) {
                    this.reportItems[i].checked = this.selectAllQuestions
                    let item = this.reportItems[i]
                    if(this.selectAllQuestions) {
                        this.checkedQuestions.add(item.uid)
                    } else {
                        this.checkedQuestions.delete(item.uid)
                    }
                }
            },
            onCheckboxInput(item) {
                console.log(`kekkok: ${item.checked}`)
                if(!item.checked) {
                    this.checkedQuestions.add(item.uid)
                } else {
                    this.checkedQuestions.delete(item.uid)
                }
            },
            applyFilter(value) {
                this.reportItems = []
                let items = JSON.parse(JSON.stringify(this.originalItems))
                for(let i = 0; items.length > i; i++) {
                    let question = items[i]
                    if((question.text.toLowerCase().includes(value.toLowerCase()) || (question.placement.toLowerCase().includes(value.toLowerCase())) || question.id.toLowerCase().includes(value.toLowerCase()))) {
                        question.checked = this.checkedQuestions.has(question.uid)
                        this.reportItems.push(question)
                    }
                }
            },
            async getReport() {
                try {
                    this.loading = true
                    this.setProgressBarTag({
                        show: true,
                        tag: 'bulkPlacementPopup',
                    })
                    const response = await this.fetchQuestionsByOrganization({})
                    this.originalItems = response.qrs
                    let items = JSON.parse(JSON.stringify(response.qrs))
                    for(let i = 0; items.length > i; i++) {
                        items[i].checked = false
                    }
                    this.reportItems = items
                    this.applyLoadMoreSettingsButton()
                } catch (e) {
                    console.log(e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.loading = false
                    this.setProgressBarTag({
                        show: false,
                        tag: 'bulkPlacementPopup'
                    })
                }
            },
            applyLoadMoreSettingsButton() {
                this.itemsShow = this.reportItems.length > this.itemsShowCount ? this.itemsShowCount : this.reportItems.length
                this.showMoreButton = this.reportItems.length > this.itemsShow
            },
            showMoreForItem() {
                this.showMoreButton = false
                let diff = this.reportItems.length - this.itemsShow
                diff = diff > this.itemsShowCount ? this.itemsShowCount : diff
                this.itemsShow += diff
                this.showMoreButton = this.reportItems.length > this.itemsShow
            },
            saveNewPlaceClick() {
                this.saveNewPlaceAction()
            },
            async saveNewPlaceAction() {
                const body = {
                    question_uids: Array.from(this.checkedQuestions),
                    placement: this.newPlaceValue
                }
                try {
                    const response = await this.bulkPlaceEdit(body)
                    this.customModalSettings = {
                        message: this.translate('bulkSuccessfulPlaceEdit'),
                        icon: 'ic_allow.svg'
                    }
                    this.showBulkPlacementPopup = false
                    this.settings.successHandler()
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },
        }
    }
</script>

<style>
    .questionItem__wrapper {
        display: flex;
        align-items: start;
        margin-left: 15px;
        margin-bottom: 10px;
        cursor: pointer;
        text-align: start;
        flex-direction: column;
        padding-bottom: 10px;
    }
    .questionItem__wrapper .custom-control-inline {
        margin-bottom: 10px;
    }
    .custom-control-label {
        padding-top: 4px !important;
    }
    .questionItem__plase {
        text-align: start;
        font-size: 14px;
        color: #363636;
    }
</style>
<style scoped>
    .checkBox-selectAll {
        text-align: start;
        margin-left: 15px;
        margin-bottom: 15px;
    }
    .results.NewPlace {
        margin-top: 15px;
    }
    .search {
        display: flex;
        flex-direction: column;
    }
    .saveBtn {
        background-color: #3F405C;
        padding: 12px 54px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;

    }
    .showMore__btn-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 20px;
    }
    .showMore__btn {
        background-color: #3F405C;
        padding: 12px 54px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
        width: auto;
    }
    .saveBtn.disable {
        background-color: #999999;
        pointer-events: none;
        cursor: not-allowed;
        color: #ffffff;
    }
    .footer-buttons {
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        width: 100%;
        justify-content: space-around;
    }
    .cancelBtn {
        cursor: pointer;
        padding: 12px 54px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        border: 2px solid #3F405C;
        border-radius: 6px;
    }
    .checkedQuestion {
        margin-top: 30px;
    }
    .suggests-search.footer {
        border: none;
    }
    .search__wrapper {
        display: flex;
        align-items: center;
    }
    .search__wrapper:first-child {
        margin-bottom: 15px;
    }
    .search__wrapper .img.placement {
        margin-left: -3px;
        opacity: .5 !important;
    }
</style>